import FrameConfig from "@lib/classes/FrameConfig";
import useContent from "@lib/use_content";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function useUpdateFrameConfig(): [boolean, string, string?] {
  const { data, loading } = useContent(["beErrGroupLogin"]);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorDebugMessage, setErrorDebugMessage] = useState<string>("");
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const [loadingConfig, setLoadingConfig] = useState(true);

  // If page was reloaded, was there an error message?
  useEffect(() => {
    if (searchParams?.get("fCError")) setErrorMessage(searchParams?.get("fCError") as string);
    if (searchParams?.get("fCDebug")) setErrorDebugMessage(searchParams?.get("fCDebug") as string);
  }, []);

  // Grab frame config from the URL.
  useEffect(() => {
    if (!data) return;
    async function updateFrameConfig() {
      let action = await new FrameConfig().updateFromURL(
        Object.fromEntries(searchParams?.entries()) || {},
      );
      let adtlQuery = (pathname?.includes("?") ? "&" : "?") + "fcu=true";
      // Preserve widget parameter if present
      if (searchParams?.get("widget")) {
        adtlQuery += `&widget=${searchParams.get("widget")}`;
      }
      if (action?.error) {
        setErrorMessage(data?.content.beErrGroupLogin);
        setErrorDebugMessage(action.error);
        adtlQuery += `&fCError=${data?.content.beErrGroupLogin}&fCDebug=${action.error}`;
      } else if (action?.redirectTo) {
        await router.replace(`/${window.siteId}/${action.redirectTo}`);
        return;
      }

      // If a group was loaded we'll want to reset the server-based props
      if (searchParams?.get("code")) await router.replace(pathname + adtlQuery);

      setLoadingConfig(false);
    }
    if (!searchParams?.get("fcu")) {
      updateFrameConfig();
    } else {
      setLoadingConfig(false);
    }
  }, [loading]);

  return [loadingConfig, errorMessage, errorDebugMessage];
}
